/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IValidateSettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.ValidateWorkflowBlock;
        processConfigId: string;
        isReadonly: boolean;
        conditions: Wars.Domain.Model.Conditions.Condition[];
        addNewCondition(): void;
        deleteCondition(index: number): void;
    }

    export class ValidateSettingsModalController extends BaseModalController {
        scope: IValidateSettingsModalControllerScope;

        constructor(
            $scope: IValidateSettingsModalControllerScope,
            workflowBlock: models.ValidateWorkflowBlock,
            processConfigId: string,
            isReadonly: boolean,
            conditionService: services.ConditionService,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;

            this.scope.workflowBlock = workflowBlock;
            this.scope.isReadonly = isReadonly;
            this.scope.processConfigId = processConfigId;
            this.scope.addNewCondition = () => this.addNewCondition();
            this.scope.deleteCondition = (index) => this.deleteCondition(index);

            conditionService.getAllConditions(processConfigId).then((conditions) => this.scope.conditions = conditions);
        }

        private addNewCondition() : void {
            this.scope.workflowBlock.validateDto.conditionIds.push(undefined);
        }

        private deleteCondition(index: number) {
            this.scope.workflowBlock.validateDto.conditionIds.splice(index, 1);
        }
    }
}

warsApp.registerController('ValidateSettingsModalController', ['$scope', 'workflowBlock', 'processConfigId', 'isReadonly', 'conditionService', 'close']);